import React from "react";
import ProgressBar from "../../../components/common/ProgressBar";
import { useMediaQuery } from "@mui/material";
import { ResponsiveRadar } from "@nivo/radar";

export default function Big5PersonalityInsightDetails(props) {
  const isOnWebScreen = useMediaQuery("(min-width:1200px)");
  const { assessment } = props;
  const personality_report =
    assessment?.personality_test_result?.personality_report;
  const personality_traits =
    assessment?.personality_test_result?.personality_traits;
  const isOnTabletScreen = useMediaQuery(
    "(min-width:768px) and (max-width:1199px)"
  );
  const isOnMobileScreen = useMediaQuery("(max-width: 767px)");
  const customLabel = (props) => {
    const anchor = props.x > 2 ? "start" : props.x < -2 ? "end" : "middle";
    return (
      <g transform={`translate(${props.x}, ${props.y})`}>
        <text alignmentBaseline={"middle"} textAnchor={anchor} fontSize={12}>
          {data.category}
        </text>
      </g>
    );
  };
  const MyResponsiveRadar = ({ data }) => (
    <ResponsiveRadar
      data={data}
      maxValue={10}
      keys={["Score"]}
      indexBy="category"
      valueFormat=">-.2f"
      margin={{ top: 10, right: 0, bottom: -10, left: 0 }}
      borderColor={{ from: "color" }}
      gridLabel={customLabel}
      gridShape="linear"
      gridLevels={4}
      gridLabelOffset={36}
      dotSize={10}
      dotColor={{ theme: "background" }}
      dotBorderWidth={2}
      colors={["#6F2DBD", "#6F2DBD", "#6F2DBD"]}
      blendMode="multiply"
      motionConfig="wobbly"
    />
  );
  const data = personality_traits
    .map((trait) => ({
      category: trait.type,
      Score: trait.normalized_score,
    }))
    .sort((a, b) => a.category.localeCompare(b.category));

  return (
    <>
      {assessment?.personality_test_result?.personality_report !== null ? (
        <div className="w-100 d-flex flex-column" style={{ gap: "24px" }}>
          <div
            className={`w-100 d-flex ${
              isOnWebScreen ? "flex-row" : "flex-column"
            } align-items-start justify-content-between`}
            style={{ gap: "24px" }}
          >
            <div>
              {/* <span className='subtitle-2 dark-50'>{`${`${assessment?.user?.first_name} ${assessment?.user?.last_name}`} Personality Type is`}</span> */} 
            </div>
            <div
              className="d-flex flex-column align-items-start"
              style={{ width: "225px", gap: "12px" }}
            >
              <div
                className="w-100 d-flex flex-row align-items-center"
                style={{ gap: "12px" }}
              >
                <span
                  className="body-2 dark-100 text-center"
                  style={{ width: "calc(100% - 100px)" }}
                >{`Role Compatibility`}</span>
                <div style={{ width: "100px" }}>
                  <ProgressBar
                    value={Math.round(
                      (assessment.personality_test_result.score / 10) * 100
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className="graph-card-personality-container"
            style={{ paddingTop: "0px" }}
          >
            <div
              className="graph-card-mid-container"
              style={{
                position: isOnMobileScreen ? "relative" : "sticky",
                right: isOnMobileScreen ? "" : "50px",
              }}
            >
              <span className="text-center" style={{ fontSize: "12px" }}>
                Agreeableness
              </span>
              <div
                style={{
                  width: isOnMobileScreen ? "100%" : "100%",
                  height: isOnMobileScreen ? "100%" : "100%",
                  marginTop: "-6px",
                }}
              >
                <MyResponsiveRadar data={data} />
              </div>
              <span
                style={{
                  fontSize: "12px",
                  position: "absolute",
                  bottom: "-25px",
                  left: "-30px",
                }}
              >
                Neuroticism
              </span>
              <span
                style={{
                  fontSize: "12px",
                  position: "absolute",
                  bottom: "90px",
                  left: "-60px",
                }}
              >
                Openness
              </span>
              <span
                style={{
                  fontSize: "12px",
                  position: "absolute",
                  bottom: "90px",
                  right: "-110px",
                }}
              >
                Conscientiousness
              </span>
              <span
                style={{
                  fontSize: "12px",
                  position: "absolute",
                  bottom: "-25px",
                  right: "-20px",
                }}
              >
                Extraversion
              </span>
            </div>
          </div>

          <div
            className="w-100 d-flex flex-column align-items-start"
            style={{ gap: "16px" }}
          >
            <span className="body-2 dark-100 text-start">
              {
                assessment?.personality_test_result?.personality_report
                  ?.executive_summary
              }
            </span>
          </div>
          <div
            className="w-100 d-flex flex-column align-items-start"
            style={{
              padding: "24px",
              borderRadius: "24px",
              border: "1px solid #ECEDF1",
              background: "#FFF",
              gap: "16px",
            }}
          >
            <span className="subtitle-2 dark-100">Strengths:</span>
            {assessment?.personality_test_result?.personality_report?.strengths?.map(
              (s, i) => (
                <div
                  key={i}
                  className="w-100 d-flex flex-column align-items-start"
                  style={{
                    padding: "24px",
                    borderRadius: "24px",
                    border: "1px solid #ECEDF1",
                    background: "#F6F5F8",
                    gap: "10px",
                  }}
                >
                  <span className="body-2 dark-50 text-start">{s.keyword}</span>
                  <span className="body-2 dark-100 text-start">
                    {s.description}
                  </span>
                </div>
              )
            )}
          </div>
          <div
            className="w-100 d-flex flex-column align-items-start"
            style={{
              padding: "24px",
              borderRadius: "24px",
              border: "1px solid #ECEDF1",
              background: "#FFF",
              gap: "16px",
            }}
          >
            <span className="subtitle-2 dark-100">Weaknesses:</span>
            {assessment?.personality_test_result?.personality_report?.weaknesses?.map(
              (w, i) => (
                <div
                  key={i}
                  className="w-100 d-flex flex-column align-items-start"
                  style={{
                    padding: "24px",
                    borderRadius: "24px",
                    border: "1px solid #ECEDF1",
                    background: "#F6F5F8",
                    gap: "10px",
                  }}
                >
                  <span className="body-2 dark-50 text-start">{w.keyword}</span>
                  <span className="body-2 dark-100 text-start">
                    {w.description}
                  </span>
                </div>
              )
            )}
          </div>
          <div
            className="w-100 d-flex flex-column align-items-start"
            style={{
              padding: "24px",
              borderRadius: "24px",
              border: "1px solid #ECEDF1",
              background: "#FFF",
              gap: "16px",
            }}
          >
            <span className="subtitle-2 dark-100">Potential career paths:</span>
            {assessment?.personality_test_result?.personality_report?.potential_job_career?.map(
              (c, i) => (
                <div
                  key={i}
                  className="w-100 d-flex flex-column align-items-start"
                  style={{
                    padding: "24px",
                    borderRadius: "24px",
                    border: "1px solid #ECEDF1",
                    background: "#F6F5F8",
                    gap: "10px",
                  }}
                >
                  <span className="body-2 dark-50 text-start">{c.keyword}</span>
                  <span className="body-2 dark-100 text-start">
                    {c.description}
                  </span>
                </div>
              )
            )}
          </div>
        </div>
      ) : (
        <div>
          <span className="body-1 danger-text">
            Personality evaluation is in progress.
          </span>
        </div>
      )}
    </>
  );
}
